import { render, staticRenderFns } from "./manageExplain.vue?vue&type=template&id=5f3b4643&scoped=true&"
import script from "./manageExplain.vue?vue&type=script&lang=js&"
export * from "./manageExplain.vue?vue&type=script&lang=js&"
import style0 from "./manageExplain.vue?vue&type=style&index=0&id=5f3b4643&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f3b4643",
  null
  
)

export default component.exports